import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import Header from './libs/header';
import AOS from 'aos';
import "aos/dist/aos.js";

import Swiper from 'swiper';
import lightbox from 'lightbox2';
import './libs/slider';
import './libs/other';
import './libs/domy';
// import './libs/kalkulator';
// import Header from './libs/header';
// import './libs/wcag'; 
// import './libs/search_club';
// import './libs/story';
// import './libs/structure';
// import './libs/patronat';
// import './libs/igrzyska';

document.addEventListener('DOMContentLoaded', function() {
    // Znajdź wszystkie elementy z klasą zaczynającą się od "aos-"
    document.querySelectorAll('[class*="aos-"]').forEach(function(el) {
        el.classList.forEach(function(c) {
            if (c.startsWith('aos-')) {
                el.setAttribute('data-aos', c.replace('aos-', ''));
            }
        });
    });

    // Inicjalizacja AOS z wolniejszymi animacjami
    AOS.init({
        duration: 1500, // czas trwania animacji w ms (domyślnie 400)
        easing: 'ease-in-out', // opcjonalnie, łagodne przyspieszanie/zwalnianie
        once: true, // animacja wykona się tylko raz
    });
});

// Your scripts here
$('#header .header').each((i, e) => {
  new Header(e, $(e));
});

const $headerE = $('#header');
const $headerP = $('.header');
const $headerT = $('.topheader');
const $btt = $('.backtotop');
$(window).on('scroll', () => {
  let scroll = window.scrollY;
  if (scroll > $headerP.height()) {
    scroll = $headerP.height();
    $headerE.addClass('header__sticky_head');
    $btt.addClass('header__sticky_head');
    $headerT.addClass('topheader__sticky_tophead');
  } else {
    $headerE.removeClass('header__sticky_head');
    $btt.removeClass('header__sticky_head');
    $headerT.removeClass('topheader__sticky_tophead');
  }
  // $headerE.css('margin-top', scroll * -1 + 'px');
});
$(window).trigger('scroll');

$('.backtotop').on('click', function(){
   $("html, body").animate({scrollTop: 0}, 1000);
});


let header__menuwrap = $('.header__menuwrap').css('width');
let sm_width = (parseInt(header__menuwrap) - 250);


$('.header .menu-parent-2 > li.sports_menu .menuusl').css('width',sm_width);
$('.header .menu-parent-2 > li.paraoli_menu .menuusl').css('width',sm_width);